import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../config.js';
import { resolvePostLoginPath } from '../utils/accessControl';

const Home = () => {
  // Load the status page script
  
  const [navbarItems, setNavbarItems] = useState([]);
  const { accessContext, isAuthReady, isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthReady) return;

    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    if (!accessContext) {
      logout().then(() => navigate('/login'));
      return;
    }

    setNavbarItems(accessContext.rawProfile || []);
    navigate(resolvePostLoginPath(accessContext));
  }, [accessContext, isAuthReady, isLoggedIn, logout, navigate]);

  return (
    <div>
      <Navbar items={navbarItems} />
      <h1>Home Page</h1>
    </div>
  );
};

export default Home;
